import('./bootstrap').catch(() => console.error('Error loading bootstrap'))
